import { Injectable } from '@angular/core';
import { getTimeZones } from '@vvo/tzdb';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  getAllTimezones() {
    return getTimeZones().map(tz => ({
      name: tz.name,
      label: `(UTC${tz.currentTimeFormat}) ${tz.name}`,
    }));
  }
}
